import React, {useContext} from 'react';
import AppVersions from './containers/AppVersions/AppVersions';
import LegalLinks from './containers/LegalLinks/LegalLinks';
import PaymentMethods from './containers/PaymentMethods/PaymentMethods';
import ReferralCodes from './containers/ReferralCodes/ReferralCodes';
import SupportReasons from './containers/SupportReasons/SupportReasons';
import { SessionContext } from '../../contexts/session/SessionContext';

const Settings = () => {
  const { permissions } = useContext(SessionContext);
  
  const editable = permissions.appSettings.edit;

  return (
    <>
      <ReferralCodes editable={editable} />
      <SupportReasons editable={editable} />
      <AppVersions editable={editable}/>
      <PaymentMethods editable={editable}/>
      <LegalLinks editable={editable}/>
    </>
  );
};

export default Settings;
